export default {
    orders: {
        actionUndo: {
            message: "Als u per ongeluk heeft geklikt, klik dan op de onderstaande link om terug te keren.",
            undo: "Klik om ongedaan te maken"
        }
    }
}